export type TSearchConfigurationsResponse = {
  content: TSearchConfigurationsContentItem[];
};

export type TSearchConfigurationsContentItem = {
  customerId: string;
  isAuthorized: boolean;
  configurations: TProjectConfiguration[];
};

export type TProjectConfiguration = {
  id: string;
  createdDate: string;
  projectConfigurationParameters: TProjectConfigurationParameter[];
  projectStatus: string;
  approximateTotalAmount: number;
  regionId: number;
  generalItems: TProjectConfigurationGeneralItem[];
};

export type TProjectConfigurationParameter = { key: string; value: string };

export type TProjectConfigurationGeneralItem = {
  code: string;
  type: string;
  name: string;
  quantity: number;
  price: number;
  complementary: boolean;
  image?: string;
  productPageName?: string;
};

export enum ProjectConfigurationParametersEnum {
  length = 'length',
  layingType = 'layingType',
  width = 'width',
  area = 'area',
  roomType = 'roomType',
}

export enum ParametersEnum {
  length = 'length',
  width = 'width',
  area = 'area',
}

export type TInputParams = Array<ParametersEnum>;

export enum RoomType {
  KITCHEN = 'kitchen',
  BATHROOM = 'bathroom',
  LIVING_ROOM = 'living_room',
  BEDROOM = 'bedroom',
  HALLWAY = 'hallway',
  NURSERY = 'nursery',
  OFFICE_SPACE = 'office_space',
}

export enum ProjectStatuses {
  NEW = 'NEW',
  SAVED = 'SAVED',
}

export type TCheckedType = {
  id: string;
  isChecked: boolean;
}[];

export type TEditConfigurationGeneralItem = {
  itemId: string;
  code: string;
  type: string;
  name?: string;
  quantity: number;
  price?: number;
  complementary: boolean;
};

export type TBasketItem = {
  code: string;
  quantity: number;
};
